import { PORTFOLIO_IMG } from "@/data/content";

export const APPROACH_CARDS = [
  {
    n: "01",
    t: "Real Asset Stewardship",
    b: "Investing in and operating institutional-grade real assets designed to deliver enduring utility, resilient value, and long-term relevance.",
    sub: "Our focus is on real assets that support how people live, recover, work, gather, and age over time.",
    img: PORTFOLIO_IMG.thangLong,
  },
  {
    n: "02",
    t: "Healthspan Platforms",
    b: "Developing next-generation healthspan platforms that integrate clinical science, wellness infrastructure, artificial intelligence, and preventive healthcare.",
    sub: "We believe healthcare will increasingly shift from reactive treatment toward prevention, longevity, and continuous wellbeing.",
    img: PORTFOLIO_IMG.chittaGroup || "/assets/4bkxivuc_CHITTA-GROUP.jpg",
  },
  {
    n: "03",
    t: "Human Capability & Knowledge Systems",
    b: "Building institutional knowledge, applied research, and organizational intelligence to strengthen long-term innovation and resilience.",
    sub: "We view human capability as core infrastructure for developing and scaling next-generation platforms.",
    img: "/assets/unsplash-1731458769726.jpg",
  },
];

export const CAPITAL_STRUCTURES = [
  {
    n: "01",
    t: "Wholly Owned",
    b: "For foundational and flagship platforms where full control protects standards, governance, brand integrity, and long-term value.",
  },
  {
    n: "02",
    t: "Strategic Partnerships",
    b: "For platforms where a long-term partner can contribute capital, operating capability, sector expertise, or market access — while Unik maintains clearly defined governance rights.",
  },
  {
    n: "03",
    t: "Co-investment Structures",
    b: "For capital-intensive assets where selected financial investors participate alongside Unik on a defined deal-by-deal basis.",
  },
  {
    n: "04",
    t: "Joint Ventures",
    b: "For new-market entry or platform replication where local or sector partners share ownership, support execution, and reduce expansion risk.",
  },
];

export const FRAMEWORK = [
  {
    structure: "Wholly Owned",
    whatItDoes: "Unik holds full equity and full control, keeping all of the risk and all of the return. This lets us set standards, governance, and brand without outside constraint.",
    whereWeApply: "Foundational and flagship assets, where control protects long-term value.",
    stage: "Early / Flagship",
  },
  {
    structure: "Strategic Partnerships",
    whatItDoes: "Unik brings in a long-term partner at the platform level. We accept some dilution in exchange for the partner's capital and operating capability, while keeping majority control and governance rights.",
    whereWeApply: "Platforms where the right partner's capital or capability can accelerate growth.",
    stage: "Growth",
  },
  {
    structure: "Co-investment Structures",
    whatItDoes: "Outside investors commit capital alongside Unik on a deal-by-deal basis. This widens our funding sources and keeps our capital efficient, while co-investors take defined, usually non-operating, governance roles.",
    whereWeApply: "Capital-intensive assets, where disciplined funding matters more than full ownership.",
    stage: "Capital-Intensive",
  },
  {
    structure: "Joint Ventures",
    whatItDoes: "Unik forms a dedicated company with a local or sector partner, and the two share both the risk and the return. The partner brings market knowledge we do not hold in-house.",
    whereWeApply: "New-market entry and platform replication, where local expertise reduces the risk of expansion.",
    stage: "Expansion",
  },
];

export const COMPOSITION = [
  {
    n: "01",
    t: "Foundational Real Assets",
    b: "Long-term ownership in residential, office, and industrial assets, supported by leasing and management capability.",
    img: PORTFOLIO_IMG.berriver,
  },
  {
    n: "02",
    t: "Partnerships & Asset Management",
    b: "Collaborations with investors and strategic partners to access a broader opportunity set and deliver capital solutions aligned with long-term stewardship.",
    img: "/assets/1u8j3q98_partner.jpg",
  },
  {
    n: "03",
    t: "Chitta Healthspan Ecosystem",
    b: "Integrated platforms that advance human health, longevity, and well-being.",
    img: "/assets/4bkxivuc_CHITTA-GROUP.jpg",
  },
];

export const EVOLUTION = [
  {
    phase: "Phase 1",
    when: "Inception",
    title: "Foundation",
    focus:
      "Establish core asset base, governance framework, and initial operating capabilities.",
    capital: [
      "· Real Assets ~70%",
      "· R&D ~15%",
      "· Technology ~10%",
      "· Operations ~5%",
    ],
    img: "/assets/zv2i0yeu_Long-Bien-Barrier.jpg",
  },
  {
    phase: "Phase 2",
    when: "2026 – 2027",
    title: "Platform Build",
    focus:
      "Develop sector platforms, institutional partnerships, and operating infrastructure.",
    capital: [
      "· Real Assets ~75%",
      "· R&D ~12%",
      "· Technology ~10%",
      "· Operations ~3%",
      "· Target: ~USD 100M deployed",
    ],
    img: "/assets/ez9kvixa_chitta-center.jpg",
  },
  {
    phase: "Phase 3",
    when: "2028 – 2029",
    title: "Scale & Revenue",
    focus:
      "Scale validated business models and strengthen recurring revenue streams.",
    capital: [
      "· Real Assets ~72%",
      "· R&D ~13%",
      "· Technology ~12%",
      "· Operations ~3%",
      "· Target EBITDA margins: ~27–35%",
    ],
    img: "/assets/g4imvvul_Chitta-Retreat.jpg",
  },
  {
    phase: "Phase 4",
    when: "2030 +",
    title: "Ecosystem Maturity",
    focus:
      "Integrate platforms into a long-term ecosystem with multiple monetisation pathways.",
    capital: [
      "· Real Assets ~80%",
      "· R&D ~8%",
      "· Technology ~10%",
      "· Operations ~2%",
    ],
    img: "/assets/9eitpmqk_hanoi-building.jpg",
  },
];
